import {
  OrganismeFichierDto,
  OrganismeFichierProjection,
  OrganismeFichierType,
  Page,
  useLazyGetOrganismeFichiersQuery,
} from '@common/services';
import { groupBy } from '@common/utils';

export function useGetInscriptionFichiers() {
  const [getOrganismeFichiers] = useLazyGetOrganismeFichiersQuery();

  return {
    getInscriptionFichiers: async (organismeId: number) => {
      const pageFichiers: Page<OrganismeFichierDto> = await getOrganismeFichiers({
        id: organismeId,
        projection: OrganismeFichierProjection.INSCRIPTION,
        page: 0,
        size: 3,
        // filters: { // fixme ne fonctionne pas
        //   'fichiers.type': [
        //     OrganismeFichierType.ATTESTATION_REPRESENTANT,
        //     OrganismeFichierType.DELEGATION_POUVOIR,
        //   ],
        // },
      }).unwrap();

      const {
        ATTESTATION_REPRESENTANT: attestation,
        DELEGATION_POUVOIR: delegation,
      } = groupBy<OrganismeFichierType, OrganismeFichierDto>('type', pageFichiers.content);

      return { attestation, delegation };
    },
  };
}